export const isYellowBlueLightBrand = (brand) => brand === 'yellowblue-light';
